<template>
  <div class="loader"></div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style scoped>
.loader {
  margin: 0 auto;
  border: 10px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>